module.exports = __webpack_public_path__ + "img/marc_s.5db52264.png";